import React from 'react';
import { Box, Button, Typography, LinearProgress } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const warmColor = '#e67e22';
const warmColorLight = '#fdf2e9';

const dcLabels = { examunimibv2: 'Esami Bicocca V2', examunimib: 'Esami Bicocca', unimib: 'Lezioni Bicocca', unimibv2: 'Lezioni Bicocca V2' };
const osLabels = { linux: 'Linux', windows: 'Windows' };
const kindLabels = { base: 'Base', custom: 'Personalizzata' };

/** Configurazione step per il flusso Esami (4 step: DC → OS → Kind → Image) */
export const EXAM_STEPS = [
    { label: 'Datacenter', getVal: (sf) => dcLabels[sf.datacenter] || sf.datacenter || '' },
    { label: 'Sistema operativo', getVal: (sf) => osLabels[sf.os] || sf.os || '' },
    { label: 'Tipo immagine', getVal: (sf) => kindLabels[sf.kindImage] || sf.kindImage || '' },
    { label: 'Immagine', getVal: (_, extra) => extra || '' },
];

/** Configurazione step per il flusso Lezioni (3 step: OS → Kind → Image) */
export const LAB_STEPS = [
    { label: 'Sistema operativo', getVal: (sf) => osLabels[sf.os] || sf.os || '' },
    { label: 'Tipo immagine', getVal: (sf) => kindLabels[sf.kindImage] || sf.kindImage || '' },
    { label: 'Immagine', getVal: (_, extra) => extra || '' },
];

function StepperSidebar({ currentStep, statusForm, selectedImageName, steps, onBack }) {
    const totalSteps = steps.length;
    const progress = ((currentStep - 1) / (totalSteps - 1)) * 100;

    return (
        <Box>
            {/* Progress bar */}
            <Box sx={{ mb: 3 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                    <Typography variant="overline" sx={{ color: warmColor, fontWeight: 700, letterSpacing: 1.5 }}>
                        Progresso
                    </Typography>
                    <Typography variant="caption" sx={{ color: warmColor, fontWeight: 600 }}>
                        {currentStep} / {totalSteps}
                    </Typography>
                </Box>
                <LinearProgress
                    variant="determinate"
                    value={progress}
                    sx={{
                        height: 6,
                        borderRadius: 3,
                        bgcolor: '#f5f0eb',
                        '& .MuiLinearProgress-bar': {
                            bgcolor: warmColor,
                            borderRadius: 3,
                            transition: 'transform 0.5s ease',
                        },
                    }}
                />
            </Box>

            {/* Steps */}
            {steps.map((s, idx) => {
                const stepNum = idx + 1;
                const isCompleted = stepNum < currentStep;
                const isActive = stepNum === currentStep;
                const value = s.getVal(statusForm, selectedImageName);

                return (
                    <Box
                        key={stepNum}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            mb: 1,
                            p: 1.5,
                            borderRadius: 2,
                            bgcolor: isActive ? warmColorLight : 'transparent',
                            border: isActive ? `2px solid ${warmColor}` : '2px solid transparent',
                            transition: 'all 0.3s ease',
                        }}
                    >
                        <Box
                            sx={{
                                width: 34,
                                height: 34,
                                borderRadius: '50%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                bgcolor: isCompleted || isActive ? warmColor : '#e8e0d8',
                                color: '#fff',
                                mr: 1.5,
                                flexShrink: 0,
                                fontSize: '0.85rem',
                                fontWeight: 'bold',
                                transition: 'all 0.3s ease',
                                boxShadow: isActive ? `0 0 0 4px rgba(230, 126, 34, 0.2)` : 'none',
                            }}
                        >
                            {isCompleted ? <CheckCircleIcon sx={{ fontSize: 20 }} /> : stepNum}
                        </Box>

                        <Box sx={{ minWidth: 0, flex: 1 }}>
                            <Typography
                                variant="body2"
                                fontWeight={isActive ? 700 : 500}
                                color={isActive || isCompleted ? 'text.primary' : 'text.disabled'}
                            >
                                {s.label}
                            </Typography>
                            {value && (isCompleted || isActive) && (
                                <Typography
                                    variant="caption"
                                    sx={{ color: warmColor, fontWeight: 600, display: 'block' }}
                                    noWrap
                                >
                                    {value}
                                </Typography>
                            )}
                        </Box>
                    </Box>
                );
            })}

            {/* Bottone indietro */}
            {onBack && (
                <Button
                    startIcon={<ArrowBackIcon />}
                    onClick={onBack}
                    variant="outlined"
                    fullWidth
                    sx={{
                        mt: 2,
                        color: warmColor,
                        borderColor: warmColor,
                        fontWeight: 600,
                        borderRadius: 2,
                        '&:hover': {
                            borderColor: '#d35400',
                            bgcolor: warmColorLight,
                        },
                    }}
                >
                    Passo precedente
                </Button>
            )}
        </Box>
    );
}

export default StepperSidebar;
